var React = require('react');

function Joystick (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M112 320H80a16 16 0 0 0-16 16v16h64v-16a16 16 0 0 0-16-16zm112-96c-11.2 0-21.8-2.14-32-5.2V352h64V218.8c-10.2 3.06-20.8 5.2-32 5.2z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M416 352H32a32 32 0 0 0-32 32v96a32 32 0 0 0 32 32h384a32 32 0 0 0 32-32v-96a32 32 0 0 0-32-32zM224 224a112 112 0 1 0-112-112 112 112 0 0 0 112 112zM200 48a24 24 0 1 1-24 24 24 24 0 0 1 24-24z","className":"fa-primary","key":2})]);
}

Joystick.defaultProps = {"viewBox":"0 0 448 512","className":"icon"};

module.exports = Joystick;

Joystick.default = Joystick;
